import React from 'react';
import {
	getNotifications,
	archiveNotifications,
	markNotificationsRead,
} from 'utils/apiRequests';
import { ApNotifications } from '@alixpartners/ui-components';

const FETCH_TIMEOUT_DELAY = 600; // 10 min

const STATE = {
	read: 'Read',
	unread: 'Unread',
};

const TYPE = {
	action: 'Actionable',
	normal: 'Normal',
};

export class Notifications extends React.Component {
	state = {
		data: [],
	};

	handleWindowBlur = () => {
		this.windowUnfocusedDateTime = new Date();
	};

	handleWindowFocus = () => {
		if (this.windowUnfocusedDateTime) {
			const currentDateTime = new Date();
			var secondsSinceFocusLost =
				(currentDateTime.getTime() - this.windowUnfocusedDateTime.getTime()) /
				1000;
			if (secondsSinceFocusLost > FETCH_TIMEOUT_DELAY) {
				this.fetchNotifications();
			}
			this.windowUnfocusedDateTime = null;
		}
	};

	componentDidMount() {
		window.addEventListener('focus', this.handleWindowFocus);
		window.addEventListener('blur', this.handleWindowBlur);
	}

	componentWillUnmount() {
		window.removeEventListener('focus', this.handleWindowFocus);
		window.removeEventListener('blur', this.handleWindowBlur);
	}

	fetchNotifications = () =>
		getNotifications().then(data =>
			this.setState({
				data: data || [],
			})
		);

	markNotificationsAsRead = () => {
		const { data } = this.state;

		const normalUnreadNotifications = data
			.filter(item => item.type === TYPE.normal && item.state === STATE.unread)
			.map(item => item.notificationId);

		if (normalUnreadNotifications.length > 0) {
			markNotificationsRead(normalUnreadNotifications).then(
				this.fetchNotifications
			);
		}
	};

	archiveNotification = id => {
		archiveNotifications(id).then(this.fetchNotifications);
	};

	render() {
		const { data } = this.state;

		if (!data) {
			return null;
		}

		return (
			<ApNotifications
				data={data}
				archive={this.archiveNotification}
				afterHide={this.markNotificationsAsRead}
				fetch={this.fetchNotifications}
			/>
		);
	}
}
